type Props = {
  children: React.ReactNode
}

export const ErrorLabel = ({ children }: Props) => {
  return (
    <p className="text-red-600 text-sm mt-2">{children}</p>
  )
}
